import React from 'react';
import PropTypes from 'prop-types';
import Done from '@material-ui/icons/Done';
import Clear from '@material-ui/icons/Clear';

const tableStyle = { color: 'rgb(242 170 0)', fontSize: '2rem' };
const ActiveCell = ({ bulkEdit, editing, ...p }) => {
  const components = [Done, Clear];
  const inverted = p.inverted || false;
  const value = Boolean(p.value);
  const Component = inverted ? components[Number(value)] : components[Number(!value)];

  const isInvalid = p.error;
  const { helperText } = p;

  return (
    <div>
      <Component
        style={{ ...tableStyle, cursor: editing ? 'pointer' : undefined }}
        onClick={editing ? () => bulkEdit(Number(!p.value), p) : undefined}
      />

      {isInvalid && (
        <div style={{ color: 'red', textAlign: 'left' }}>{helperText}</div>
      )}
    </div>
  );
};

ActiveCell.propTypes = {
  bulkEdit: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  editing: PropTypes.bool.isRequired,
};

export default ActiveCell;
